<template>
  <HeaderH5 v-if="isH5" :scrollTop="scrollTop" :current="current" :menuList="menuList">
  </HeaderH5>
  <HeaderWeb v-else :scrollTop="scrollTop" :current="current" :menuList="menuList">
  </HeaderWeb>
</template>

<script>
import HeaderH5 from './HeaderH5.vue'
import HeaderWeb from './HeaderWeb.vue'

export default {
  components: { HeaderH5, HeaderWeb },
  props: {
    scrollTop: {
      type: Number,
      default: 0,
    },
    current: {
      type: Array,
      default: () => ["home"],
    },
  },
  data() {
    return {
      isH5: false,
      menuList: [{
        key: 'home',
        name: "首页",
        path: '/home'
      }, {
        key: 'product',
        name: "产品中心",
        path: '/product',
        children: [
          {
            key: 'product',
            name: "首页",
            path: '/product'
          },
          // {
          //   key: 'lake',
          //   name: "智慧河湖",
          //   path: '/lake'
          // },
          // {
          //   key: 'fireProtection',
          //   name: "智慧消防",
          //   path: '/fireProtection'
          // },
          // {
          //   key: 'agriculture',
          //   name: "智慧农业",
          //   path: '/agriculture'
          // },
          // {
          //   key: 'community',
          //   name: "智慧社区",
          //   path: '/community'
          // },
          // // {
          // //   key: 'retirement',
          // //   name: "智慧养老",
          // //   path: '/retirement'
          // // },
          // {
          //   key: 'businessCard',
          //   name: "企业名片",
          //   path: '/businessCard'
          // },
          // {
          //   key: 'storeYard',
          //   name: "放心消费一码通",
          //   path: '/storeYard'
          // },
          // {
          //   key: 'distributionMall',
          //   name: "分销商城",
          //   path: '/distributionMall'
          // },
          // {
          //   key: 'industrialEconomy',
          //   name: "工业经济监测平台",
          //   path: '/industrialEconomy'
          // },
          // {
          //   key: 'customization',
          //   name: "APP小程序定制开发",
          //   path: '/customization'
          // },
          // {
          //   key: 'systemCustomization',
          //   name: "系统定制",
          //   path: '/systemCustomization'
          // },
          {
            key: 'weedingRobot',
            name: "石塑箱",
            path: '/weedingRobot'
          },
          {
            key: 'transportRobot',
            name: "石塑建材",
            path: '/transportRobot'
          },
          // {
          //   key: 'irrigationSystem',
          //   name: "太阳能阀门控制器",
          //   path: '/irrigationSystem'
          // },
        ]
      },
      // {
      //   key: 'solution',
      //   name: "解决方案",
      //   path: '/solution',
      //   children: [
      //     {
      //       key: 'solution',
      //       name: "首页",
      //       path: '/solution'
      //     },
      //     {
      //       key: 'solutionFireProtection',
      //       name: "智慧消防解决方案",
      //       path: '/solutionFireProtection'
      //     },
      //     {
      //       key: 'solutionRetirement',
      //       name: "智慧养老解决方案",
      //       path: '/solutionRetirement'
      //     },
      //     {
      //       key: 'solutionCommunity',
      //       name: "智慧社区解决方案",
      //       path: '/solutionCommunity'
      //     },
      //     {
      //       key: 'irrigationSystem',
      //       name: "农业灌溉解决方案",
      //       path: '/irrigationSystem'
      //     },
      //     // {
      //     //   key: 'companyWeb',
      //     //   name: "企业网站99元建站",
      //     //   path: '/companyWeb'
      //     // }
      //   ],
      // },
      // {
      //   key: 'companyConsult',
      //   name: "企业资讯",
      //   path: '/companyConsult'
      // },
      {
        key: 'cooperation',
        name: "合作共赢",
        path: '/cooperation'
      }, {
        key: 'aboutUs',
        name: "关于我们",
        path: '/aboutUs'
      }],
    }
  },
  created() {
    this.judgeH5()

    const that = this
    window.addEventListener('resize', function () {
      that.judgeH5()
    }, false)
  },

  methods: {
    judgeH5() {
      this.isH5 = window.innerWidth < 768
    }
  }

}
</script>

<style lang="less" scoped></style>
